const CROW_IMG = 'https://customer-assets.emergentagent.com/job_466cd153-1355-4be2-afa5-ec75ce7c4c41/artifacts/62qasuap_pai-crow-png.png';

export default function CrowStory() {
  return (
    <section className="max-w-4xl mx-auto px-6 py-8" data-testid="crow-story-section">
      <div className="border border-slate-200 rounded-xl p-6 flex flex-col sm:flex-row gap-5 items-start">
        <div className="flex-shrink-0 w-[140px]">
          <img
            src={CROW_IMG}
            alt="The Crow and the Pitcher"
            className="w-full h-auto rounded-lg"
            data-testid="crow-image"
          />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-base text-slate-900 mb-2">Why this matters</h3>
          <p className="text-sm text-slate-600 mb-2">
            In an old story, a crow finds water it cannot reach. Instead of forcing the problem, it adds small pebbles — raising the water one step at a time.
          </p>
          <p className="text-sm text-slate-600 mb-2">
            Healthcare works the same way. Your story matters — but it often gets lost or fragmented.
          </p>
          <p className="text-sm text-slate-700 font-medium">
            P.AI Global Health (Patient AI) helps structure your information so your doctor can see clearly from the start.
          </p>
        </div>
      </div>
    </section>
  );
}
